import React from "react";
import { menuNavigation } from "../../Main/actions";
// import { openCloseAccountPopOver, openCloseAppStack } from "../../Header/actions";
// import { setPopOverStatus } from "../../Header/Notificaciones/actions";

export default (dispatchCallback) => [
  {
    selector: "#trabajador_main_menu",
    content: () => {
      dispatchCallback(menuNavigation({
        activeIndex: 1,
        hoverIndex: 1,
        isHovering: true,
      }));
      return (
        <div>
          <h3>Trabajador</h3>
          En esta sección tendrás acceso a todo lo necesario para tus gestiones como trabajador.
        </div>
      );
    },
  },
  {
    selector: "#trabajador_siniestros",
    content: () => {
      dispatchCallback(menuNavigation({
        activeIndex: 1,
        hoverIndex: 1,
        isHovering: true,
      }));
      return (
        <div>
          <h3>Siniestros</h3>
          Aquí podrás ver el historial de siniestros, desde tus periodos de reposo hasta tus prestaciones económicas, y además podrás descargar tus certificados.
        </div>
      );
    },
  },
  {
    selector: "#mi_cuenta_main_menu",
    content: () => {
      dispatchCallback(menuNavigation({
        activeIndex: 5,
        hoverIndex: 5,
        isHovering: true,
      }));
      return (
        <div>
          <h3>Mi cuenta</h3>
          Ahora podrás gestionar tus datos en un solo lugar. ¡Recuerda que tu cuenta y usuario son personales!
        </div>
      );
    },
  },
  {
    selector: "#mi_cuenta_mi_cuenta",
    content: () => (
      <div>
        <h3>General</h3>
        En esta sección podrás visualizar y modificar tu información. Recuerda que tus datos servirán para agilizar los procesos y/o gestiones de tu empresa.
      </div>
    ),
  },
  // TOUR GUIADO NOTIFICACIONES
  // {
  //   selector: "#mi_cuenta_notificaciones",
  //   content: () => (
  //     <div>
  //       <h3>Notificaciones</h3>
  //       En esta sección podrás configurar las notificaciones que recibirás como trabajador a través de tu correo electrónico y/o un sms a tu celular.
  //     </div>
  //   ),
  // },
  {
    selector: "#mi_cuenta_solicitudes",
    content: () => {
      dispatchCallback(menuNavigation({
        activeIndex: 5,
        hoverIndex: 5,
        isHovering: true,
      }));
      return (
        <div>
          <h3>Solicitudes</h3>
          Si necesitas tener acceso para gestionar una empresa, solo debes enviar una solicitud y esperar a que el encargado de la empresa la apruebe.
        </div>
      );
    },
  },
  // TOUR GUIADO NOTIFICACIONES
  // {
  //   selector: "#btnNotificacion",
  //   content: () => (
  //     <div>
  //       <h3>Notificaciones</h3>
  //       Implementamos un nuevo sistema de notificaciones para mantenerte informado de tus gestiones y distintos procesos que te puedan interesar.
  //     </div >
  //   ),
  // },
  {
    selector: "#btnAppStack",
    content: () =>
      // dispatchCallback(openCloseAccountPopOver(false));
      // dispatchCallback(openCloseAppStack(true));
      (
        <div>
          <h3>Acceso único</h3>
          Desde hoy podrás acceder directamente a todos los portales desde un mismo lugar y con una misma cuenta.
        </div>
      )
    ,
  },
  {
    selector: "#btnUserInfo",
    content: () => (
      <div>
        <h3>Cerrar sesión</h3>
        Recuerda cerrar sesión cuando hayas terminado ya que la información que maneja la plataforma es confidencial.
        </div >
    ),
  },
];

